import React from 'react';
import { FaLink } from 'react-icons/fa';

const SiteTable = ({ data }) => {
  // Sort the data by name in alphabetical order
  const sortedData = [...data].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <table className="site-table">
      <thead>
        <tr>
          <th>URL</th>
          <th>Name</th>
          <th>Location</th>
          <th>ID</th>
        </tr>
      </thead>
      <tbody>
        {sortedData.map((site) => (
          <tr key={site.ID}>
            <td className="url-column">
              <a href={site.URL} target="_blank" rel="noopener noreferrer">
                <FaLink />
              </a>
            </td>
            <td>{site.name}</td>
            <td>{site.Location}</td>
            <td>{site.ID}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SiteTable;
